export default "__VITE_ASSET__DatEmHDg__"